var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ElInputInteger"},[_c('el-input',{model:{value:(_vm.valueUse),callback:function ($$v) {_vm.valueUse=$$v},expression:"valueUse"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }